import { render, staticRenderFns } from "./PresentacionUpdateActionButtonsClub.vue?vue&type=template&id=add772fe&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports